export default __webpack_public_path__ + "static/media/logoFbh.b5f02147.png";